import React from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'

function Variant({ variation, className }) {
  return (
    <span className={`${styles.variation} ${parseInt(variation) < 0 ? styles.red : styles.green} ${className}`}>
      <Icon name='grow' size='small' />
      {variation}
    </span>
  )
}

export default Variant
